import React from 'react';
import { ProjectCredentials } from '../types';

type Props = {
  credentials: Partial<ProjectCredentials>;
  isEditing: boolean;
  onToggleEdit: () => void;
  onSave: (e: React.FormEvent) => void;
  onChange: (field: keyof ProjectCredentials, value: string) => void;
};

export default function SettingsSection({ credentials, isEditing, onToggleEdit, onSave, onChange }: Props) {
  return (
    <div className="space-y-8">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold text-gray-900">Configurações e Credenciais</h3>
        <button onClick={onToggleEdit} className="bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700">
          <i className="ri-edit-line mr-2"></i>{isEditing ? 'Cancelar' : 'Editar'}
        </button>
      </div>
      <form onSubmit={onSave} className="space-y-8">
        <div className="bg-gray-50 rounded-lg p-6">
          <h4 className="text-lg font-semibold text-gray-900 mb-4">Banco de Dados</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input type="text" placeholder="Tipo (ex: PostgreSQL)" value={credentials.database_type || ''} onChange={(e) => onChange('database_type', e.target.value)} disabled={!isEditing} className="w-full p-2 border rounded disabled:bg-gray-200" />
            <input type="text" placeholder="Host" value={credentials.database_host || ''} onChange={(e) => onChange('database_host', e.target.value)} disabled={!isEditing} className="w-full p-2 border rounded disabled:bg-gray-200" />
            <input type="text" placeholder="Porta" value={credentials.database_port || ''} onChange={(e) => onChange('database_port', e.target.value)} disabled={!isEditing} className="w-full p-2 border rounded disabled:bg-gray-200" />
            <input type="text" placeholder="Nome do Banco" value={credentials.database_name || ''} onChange={(e) => onChange('database_name', e.target.value)} disabled={!isEditing} className="w-full p-2 border rounded disabled:bg-gray-200" />
            <input type="text" placeholder="Usuário" value={credentials.database_user || ''} onChange={(e) => onChange('database_user', e.target.value)} disabled={!isEditing} className="w-full p-2 border rounded disabled:bg-gray-200" />
            <input type="password" placeholder="Senha" value={credentials.database_password || ''} onChange={(e) => onChange('database_password', e.target.value)} disabled={!isEditing} className="w-full p-2 border rounded disabled:bg-gray-200" />
          </div>
        </div>
        <div className="bg-gray-50 rounded-lg p-6">
          <h4 className="text-lg font-semibold text-gray-900 mb-4">GitHub</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input type="text" placeholder="Repositório" value={credentials.github_repository || ''} onChange={(e) => onChange('github_repository', e.target.value)} disabled={!isEditing} className="w-full p-2 border rounded disabled:bg-gray-200 md:col-span-2" />
            <input type="text" placeholder="Branch" value={credentials.github_branch || ''} onChange={(e) => onChange('github_branch', e.target.value)} disabled={!isEditing} className="w-full p-2 border rounded disabled:bg-gray-200" />
            <input type="password" placeholder="Token" value={credentials.github_token || ''} onChange={(e) => onChange('github_token', e.target.value)} disabled={!isEditing} className="w-full p-2 border rounded disabled:bg-gray-200" />
          </div>
        </div>
        {isEditing && (
          <div className="flex justify-end">
            <button type="submit" className="bg-indigo-600 text-white px-6 py-2 rounded-lg hover:bg-indigo-700"><i className="ri-save-line mr-2"></i>Salvar</button>
          </div>
        )}
      </form>
    </div>
  );
}